export default "__VITE_ASSET__XIDSqFu6__"